import { render } from "./index-edit.vue?vue&type=template&id=4b23672f"
import script from "./index-edit.vue?vue&type=script&lang=js"
export * from "./index-edit.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Projects\\YCTECH\\ycform\\trunk\\ycform-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__